export default {
  title: 'Invoice alerts',
  new: {
    title: 'New delegation',
    single: 'Delegation',
    action: 'Add configuration'
  },
  provider: `Provider's email`,
  acc: {
    first: 'Sent invoices alert',
    second: 'Sent selfinvoices alert',
    third: 'Recieved invoices alert',
    fourth: 'Recieved selfinvoices alert'
  },
  copy: 'Copy configuration of the invoice',
  form: {
    language: 'Language ',
    email: 'Email*',
    emited: 'When it is issued',
    read: 'When it is read',
    accepted: 'When it is accepted',
    refused: 'When it is rejected',
    edited: 'When it is rectified',
    ignored: 'When not read in 7 days'
  },
  delete: {
    title: 'List of alerts to delete',
    success: 'The alerts have been deleted.'
  },
  errors: {
    title: 'Please, check the following data',
    unavailable: `You can't add new alert, all the delegations have alerts configured`,
    setup: 'There is an error on the notifications setup.'
  }
}
